/* eslint-disable @wix/da/window-object-typeof-check */
import { useEffect, useRef } from 'react';
import pick from 'lodash/pick';
var getCallbackValue = function (hasSupport, e) {
    if (!hasSupport) {
        return {
            offsetLeft: 0,
            offsetTop: 0,
            height: document.documentElement.clientHeight,
            width: document.documentElement.clientWidth,
            scale: 1,
            pageLeft: 0,
            pageTop: 0,
        };
    }
    if (e) {
        // We don't send the object back because in IOS the reference became always equal
        // and then clientcode would not update like they expected
        return pick(e.target, [
            'offsetLeft',
            'offsetTop',
            'pageLeft',
            'pageTop',
            'width',
            'height',
            'scale',
        ]);
    }
    return window.visualViewport;
};
export function useVisualViewport(onViewportUpdate, enabled) {
    var pendingUpdate = useRef(false);
    var supportsVisualViewport = typeof window !== 'undefined' && window.visualViewport;
    useEffect(function () {
        if (supportsVisualViewport && enabled) {
            onViewportUpdate(window.visualViewport);
        }
    }, [onViewportUpdate, supportsVisualViewport, enabled]);
    // The real api
    useEffect(function () {
        if (!supportsVisualViewport || !enabled) {
            return;
        }
        var viewportHandler = function (e) {
            if (pendingUpdate.current) {
                return;
            }
            pendingUpdate.current = true;
            requestAnimationFrame(function () {
                pendingUpdate.current = false;
                onViewportUpdate(getCallbackValue(supportsVisualViewport, e));
            });
        };
        window.visualViewport.addEventListener('scroll', viewportHandler);
        window.visualViewport.addEventListener('resize', viewportHandler);
        return function () {
            window.visualViewport.removeEventListener('scroll', viewportHandler);
            window.visualViewport.removeEventListener('resize', viewportHandler);
        };
    }, [pendingUpdate, onViewportUpdate, supportsVisualViewport, enabled]);
    // Fake it for older browsers, not a full polyfill because it doesn't deal with
    // scale or the offsets
    useEffect(function () {
        if (supportsVisualViewport || !enabled) {
            return;
        }
        onViewportUpdate(getCallbackValue(supportsVisualViewport));
        var viewportHandler = function (e) {
            if (pendingUpdate.current) {
                return;
            }
            pendingUpdate.current = true;
            requestAnimationFrame(function () {
                pendingUpdate.current = false;
                onViewportUpdate(getCallbackValue(supportsVisualViewport));
            });
        };
        window.addEventListener('scroll', viewportHandler);
        window.addEventListener('resize', viewportHandler);
        return function () {
            window.removeEventListener('scroll', viewportHandler);
            window.removeEventListener('resize', viewportHandler);
        };
    }, [enabled, onViewportUpdate, supportsVisualViewport]);
}
//# sourceMappingURL=useVisualViewport.js.map